// extracted by mini-css-extract-plugin
export default {"container":"UserLocationPanel_container__21Ye9","title":"UserLocationPanel_title__WPPK1"};